export const CURRENCY_CHANGE = "CURRENCY_CHANGE";

export const CURRENCY_ACCOUNT_CHANGE = "CURRENCY_ACCOUNT_CHANGE";

export const CURRENCY_GET = "CURRENCY_GET";
export const CURRENCY_GET_SUCCESS = "CURRENCY_GET_SUCCESS";
export const CURRENCY_GET_FAILED = "CURRENCY_GET_FAILED";
